module.exports = {"360123100":"龙津镇","360123101":"万埠镇","360123102":"石鼻镇","360123103":"鼎湖镇","360123104":"长埠镇","360123105":"东阳镇","360123106":"黄洲镇","360123200":"乔乐乡","360123201":"长均乡","360123202":"新民乡","360123402":"江西安义工业园区","360123501":"国营万埠垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360123.json
// module id = 1156
// module chunks = 0